<template>
  <el-dialog :destroy-on-close="true" :visible.sync="dialogVisible" width="30%" :before-close="close">
    <div slot="title" class="title">审核</div>
    <div>
      <el-form
        size="small"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        label-position="top"
      >
		<el-form-item label="审核选择" >
			<el-radio-group v-model="ruleForm.status" @change="onRadio">
				<el-radio label="1">通过</el-radio>
				<el-radio label="2">拒绝</el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item v-if="refuse" label="" prop="reason">
		  <el-input v-model="ruleForm.reason" placeholder="请输入拒绝原因" type="textarea"></el-input>
		</el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="small-btn btn-bor" size="small" @click="close"
        >取 消</el-button
      >
      <el-button
        class="small-btn bgC"
        size="small"
        type="primary"
        @click="submitForm('ruleForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
	  disabled: {
	    type: Boolean,
	    default() {
	      return false;
	    },
	  },
	
	accountObj:{
		type:Object,
		default(){
			return {}
		}
	}
  },
  data() {
    return {
      dialogVisible: false,
	  refuse:false,
      ruleForm: {
	    id:'',
	    status: '1',
        reason: "",
      },
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }],
      },
    };
  },
  methods: {
	  onRadio(){
		this.refuse = this.ruleForm.status == 2?true:false;
	  },
    //   提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
			this.$emit('examine',this.ruleForm)
        } else {
          this.$message.error("请输入必填项！");
          return false;
        }
      });
    },
    //   关闭弹框
    close() {
      this.dialogVisible = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.title {
  text-align: left;
}
.el-form-item__label {
  padding: 0 !important;
}
.el-form-item {
  margin-bottom: 0 !important;
  padding: 5px 30px;
}
.el-dialog__body {
  padding-top: 10px;
}
.el-dialog {
  border-radius: 8px;
}
.el-dialog__footer {
  padding-top: 0;
  text-align: center;
}
.small-btn:hover {
  opacity: 0.8 !important;
}
.small-btn:active {
  opacity: 0.9 !important;
}
</style>